/* Componente per l'aggiunta mappa del button per aprire il menù "Query" */
import React from 'react'
import {Component} from 'react'
import { connect } from 'react-redux';
import addLayerImage from './Query_black.svg'
import {setOpenQuery} from '../redux';
import Tooltip from '@material-ui/core/Tooltip';
 class ButtonQuery extends Component {
    
constructor(props){
    super(props);
    this.state = {
        buttonStyle: props.button,

        isToggleOn: true
      }
          // This binding is necessary to make `this` work in the callback
        
          
          this.handleClick = this.handleClick.bind(this);
}

handleClick() {
    
    this.setState(function(prevState) {
        this.props.openMenu(true)
        return {isToggleOn: !prevState.isToggleOn};
    });
    
}
componentDidUpdate(){
    if (this.props.openQuery.state === true){
        this.props.openMenu(true)
        this.props.setOpenQuery({state:false,name:''})
    }
    // return {isToggleOn: this.props.openQuery};
}
render() {   
    return (
        // <Slide direction="left" in={this.state.isToggleOn } >
        <Tooltip title="Menù Query">
        <button  style={ this.state.buttonStyle} onClick={this.handleClick}>
            <img style={{width: '22px',height: '22px'}} src={addLayerImage}  alt="trip"/>
        </button>
        </Tooltip>
        )
    }
}
const mapStateToProps = state => {
    return {
        openQuery:state.openQuery.openQuery
    }
  }
  const mapDispatchToProps = dispatch => {
    return {
      setOpenQuery: (openQuery) => dispatch(setOpenQuery(openQuery))
     }
  }
  export default connect(mapStateToProps,mapDispatchToProps)(ButtonQuery)